import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';
import withoutNulls from '../../api/search/withoutNulls';

const WORKSPACES_DOC = 'workspaces';
const CURRENT_VERSION = 'v1';

const workspaceConverter = {
  toFirestore(app: V3.Workspace): firebase.firestore.DocumentData {
    return withoutNulls({ ...app });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<V3.Workspace>,
    options: firebase.firestore.SnapshotOptions,
  ): V3.Workspace {
    const data: V3.Workspace = {
      ...snapshot.data(options),
    };

    const workspace: V3.Workspace = {
      ...data,
      adminUserIds: data.adminUserIds ? data.adminUserIds : [],
      appViewersAccess: data.appViewersAccess
        ? data.appViewersAccess
        : {
            isPublic: false,
            userIds: [],
            groupIds: [],
          },
    };

    return workspace;
  },
};

const getWorkspacesRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.CONTENT_DISTRIBUTIONS_COLLECTION)
    .doc(WORKSPACES_DOC)
    .collection(CURRENT_VERSION)
    .withConverter(workspaceConverter);
};

export default getWorkspacesRef;
